<template>
    <div class="report-energy-item " :class="'energy-'+itemData.textEn">
        <div class="report-ei-title">{{ itemData.text }}</div>
        <div class="report-ei-bar">
            <div class="report-ei-bar-bg">
                <div class="report-ei-bar-progress" :style="'height:'+(itemData.value < 50 ? (itemData.value+15) : itemData.value)+'%'"></div>
            </div>
            <div class="report-ei-bar-percent">
                <span>{{ itemData.value }}%</span>
            </div>
        </div>
        <div class="report-ei-icon">
            <i class="iconbg " :class="'icon-'+itemData.textEn"></i>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ReportEnergyItem',
    props: {
        itemData: {
            type: Object,
            default() {
                return {}
            }
        },
    },
    mounted() {
        
    },
    methods: {
        
    }
}
</script>